import { IApiQueryResponse } from '@llws/api-common';
import { dispatch } from '../../store';
import {
  feesQueueDataReceived, subscriptionListReceived,
} from './subscriptionsSlice';
import { ISubscriptionsWithInvoices } from './interfaces';
import { apiFetch } from '../../utils';
import { REACT_APP_API_ROOT_URI } from '../../../App';
import { ISubscriptions } from '@llws/lift-entity-interfaces';

export const getSubsforClient = async (freshbooksClientId:number) => {
  const url = `${REACT_APP_API_ROOT_URI}/subscriptions/${freshbooksClientId}`;
  const response = await apiFetch(url);
  const responseData = await response.json() as IApiQueryResponse< ISubscriptions >;

  dispatch(subscriptionListReceived(responseData)); // ISSUE:#154: Error handling?
};

export const getFeesQueue = async (forTesting: boolean = false) => {
  const url = `${REACT_APP_API_ROOT_URI}/subscriptions/fees_queue${forTesting?'?filterUsed=0':''}`;
  const response = await apiFetch(url);
  const responseData = await response.json() as IApiQueryResponse<ISubscriptionsWithInvoices>;
  dispatch(feesQueueDataReceived(responseData)); // TODO: Error handling?
};

/**
 * Sends a DELETE request to permanently remove a subscription and all its related records.
 *
 * The API will reject the request if the subscription has any associated invoices, charges,
 * or reporting/attribution data that requires manual review before deletion.
 *
 * @param subscriptionId - The numeric ID of the subscription to delete.
 * @returns `true` if the deletion was successful (HTTP 2xx), `false` otherwise.
 */
export const deleteSubscription = async (subscriptionId: number): Promise<boolean> => {
  const url = `${REACT_APP_API_ROOT_URI}/lift_subscriptions/${subscriptionId}`;
  const response = await apiFetch(url, { method: 'DELETE' });
  return response.ok;
};
